var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiRrCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_680_69675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3189 4.43107L8.49988 18.2491C8.40697 18.3423 8.29655 18.4164 8.17497 18.4669C8.05339 18.5174 7.92303 18.5434 7.79138 18.5434C7.65972 18.5434 7.52937 18.5174 7.40778 18.4669C7.2862 18.4164 7.17579 18.3423 7.08288 18.2491L1.73888 12.9001C1.64597 12.8068 1.53555 12.7328 1.41397 12.6823C1.29239 12.6318 1.16203 12.6058 1.03038 12.6058C0.898723 12.6058 0.768365 12.6318 0.646783 12.6823C0.5252 12.7328 0.414787 12.8068 0.321877 12.9001C0.2286 12.993 0.154588 13.1034 0.104086 13.225C0.0535845 13.3466 0.0275879 13.4769 0.0275879 13.6086C0.0275879 13.7402 0.0535845 13.8706 0.104086 13.9922C0.154588 14.1137 0.2286 14.2242 0.321877 14.3171L5.66788 19.6621C6.23182 20.225 6.99607 20.5411 7.79288 20.5411C8.58968 20.5411 9.35393 20.225 9.91788 19.6621L23.7359 5.84707C23.829 5.75418 23.9029 5.64383 23.9533 5.52234C24.0037 5.40085 24.0297 5.2706 24.0297 5.13907C24.0297 5.00753 24.0037 4.87729 23.9533 4.7558C23.9029 4.63431 23.829 4.52396 23.7359 4.43107C23.643 4.33779 23.5326 4.26378 23.411 4.21328C23.2894 4.16278 23.159 4.13678 23.0274 4.13678C22.8957 4.13678 22.7654 4.16278 22.6438 4.21328C22.5222 4.26378 22.4118 4.33779 22.3189 4.43107Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_680_69675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrCheck);
export default __webpack_public_path__ + "static/media/fi-rr-check.81ab6c3f260c178571c8c038b47af757.svg";
export { ForwardRef as ReactComponent };